import { render, staticRenderFns } from "./NotesChanged.vue?vue&type=template&id=4f9f96be&scoped=true&"
import script from "./NotesChanged.vue?vue&type=script&lang=js&"
export * from "./NotesChanged.vue?vue&type=script&lang=js&"
import style0 from "./NotesChanged.vue?vue&type=style&index=0&id=4f9f96be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f96be",
  null
  
)

export default component.exports